<div style="position: relative;" (appClickOutside)="onClickOutside()" [style.z-index]="zIndex" data-cy="basic-dropdown-container">
  <div (click)="onDropDownButtonClick()" class="tdo-basic-dropdown-button" [style.width]="width" [style.height]="height" data-cy="basic-dropdown-button">
    <div style="position:relative; left: 12px; top: 11px; flex: 1; font-size: 12px;" data-cy="basic-dropdown-placeholder-label">{{placeholder}}</div>
    <div style="flex-basis: 1px; background-color: rgba(0,0,0,0.03);"></div>
    <div [style.flex-basis]="'30px'" style="user-select: none;" data-cy="basic-dropdown-arrow-icon-container">
      <div style="color: #00A1DD; font-size: 32px; position: relative; transform: translate(-50%, -50%); top: 50%; left: 60%;">
        <mat-icon data-cy="basic-dropdown-arrow-icon">keyboard_arrow_down</mat-icon>
      </div>
    </div>
  </div>
  <div class="tdo-basic-dropdown"  [ngClass]="{'tdo-basic-dropdown-menu-show': isShowMenu}"
       [style.top.px]="dropdownYOffset"
       [style.left.px]="dropdownXOffset"
       [style.width]="dropDownWidth" data-cy="basic-dropdown-menu">
    <div class="tdo-basic-dropdown-backdrop" [style.max-height]="dropDownHeight" data-cy="basic-dropdown-options-container">
      <div (click)="onItemSelected(model)" *ngFor="let model of dataSet" data-cy="basic-dropdown-option">
        <div class="tdo-basic-dropdown-item" data-cy="basic-dropdown-option-label">{{model.label}}</div>
      </div>
    </div>
  </div>
</div>
